/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-template-curly-in-string */
import React, { useState, useEffect } from "react";
import {
  Form,
  Row,
  Col,
  Switch,
  Modal,
  message,
} from "antd";

//import other files and API function
import { lookUpDetails } from "../../../api/LookUpAPI";
import { updateState } from "../../../api/StatesAPI";
import { useBulkCasePharmacyUpdate } from './useBulkCasePharmacyUpdate';
import StateForm from "./StateForm";

const EditState = (props) => {
  const {
    stateId,
    afterStateEdit,
    fetchStatesAfterUpdate,
    states,
    telemedicineCategory,
    consultationType,
    listOfPharmacies,
    fetchPharmacies,
    pharmacyLoading,
  } = props;
  const [addedTeleMedicineCategory, setAddedTeleMedicineCategory] = useState(
    []
  );

  const [form] = Form.useForm();
  const [fields, setStateDetails] = useState([
    {
      name: ["stateName"],
      value: "",
    },
    {
      name: ["oneClickPrescribeEligible"],
      value: false,
    },
  ]);

  const { addCategory, removeCategory, hasCategoryUpdates, bulkUpdateCasePharmacies } = useBulkCasePharmacyUpdate();

  useEffect(() => {
    lookUpDetails("state", stateId)
      .then((res) => {
        if (res.data && res.data.payload) {
          const { name, consultationType, renewalConsultationType, pharmacy, pdmpResource, oneClickPrescribeEligible = false } = res.data.payload;
          setStateDetails([
            { name: ["stateName"], value: name || "" }, 
            { name: ["pdmpResource"], value: pdmpResource || "" },
            { name: ["oneClickPrescribeEligible"], value: oneClickPrescribeEligible }
          ]);
          const consultationTypeDetails = [];
          if (pharmacy && pharmacy.length) {
            consultationType.forEach((eachConsultationType) => {
              const correspondingPharmacy = pharmacy.filter(
                (eachPharmacy) =>
                  eachPharmacy.categoryId === eachConsultationType.categoryId
              );
              if (correspondingPharmacy && correspondingPharmacy.length) {
                consultationTypeDetails.push({
                  ...eachConsultationType,
                  renewalConsultationType: renewalConsultationType?.find(({ categoryId }) => eachConsultationType.categoryId === categoryId)?.consultationType,
                  pharmacyName: correspondingPharmacy[0].pharmacyName,
                  pharmacyId: correspondingPharmacy[0].pharmacyId,
                });
              } else {
                consultationTypeDetails.push({
                  ...eachConsultationType,
                  renewalConsultationType: renewalConsultationType?.find(({ categoryId }) => eachConsultationType.categoryId === categoryId)?.consultationType,
                });
              }
            });
          } else {
            consultationType.forEach((eachConsultationType) => {
              consultationTypeDetails.push({
                ...eachConsultationType,
                renewalConsultationType: renewalConsultationType?.find(({ categoryId }) => eachConsultationType.categoryId === categoryId)?.consultationType,
              });
            });
          }
          setAddedTeleMedicineCategory(consultationTypeDetails);
          message.success(
            "Successfully loaded State details into Edit State Form"
          );
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Unable to fetch state details for Editing");
      });
  }, [stateId]);

  const onFinish = (values) => {
    const { stateName, shouldBulkUpdatePharmacy, pdmpResource, oneClickPrescribeEligible } = values;
    if (!addedTeleMedicineCategory.length) {
      return false;
    }
    if (oneClickPrescribeEligible) {
      window.alert("Ensure desired telemedicine category is also configured for Clinical Eligibility Validator");
    }
    const consultationTypeDetails = addedTeleMedicineCategory.map(
      (eachCategory) => ({
        categoryId: eachCategory.categoryId,
        categoryName: eachCategory.categoryName,
        consultationType: eachCategory.consultationType,
      })
    );

    const renewalConsultationTypeDetails = addedTeleMedicineCategory.filter(category => category.renewalConsultationType).map(
      (eachCategory) => ({
        categoryId: eachCategory.categoryId,
        categoryName: eachCategory.categoryName,
        consultationType: eachCategory.renewalConsultationType,
      })
    );

    const pharmacyDetails = addedTeleMedicineCategory.map((eachCategory) => ({
      categoryId: eachCategory.categoryId,
      pharmacyName: eachCategory.pharmacyName,
      pharmacyId: eachCategory.pharmacyId,
    }));

    const stateDetails = {
      name: stateName,
      consultationType: [...consultationTypeDetails],
      renewalConsultationType: [...renewalConsultationTypeDetails],
      pharmacy: [...pharmacyDetails],
      pdmpResource,
      oneClickPrescribeEligible
    };

    updateState(stateId, stateDetails)
      .then((res) => {
        const { data } = res;
        if (data && data.success) {
          message.success("Successfully updated state");
        } else {
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error("Unable to update State. Please try again!");
          }
        }
        afterStateEdit("");
        fetchStatesAfterUpdate();
      })
      .then(async () => {
        if (shouldBulkUpdatePharmacy && hasCategoryUpdates) {
          const res = await bulkUpdateCasePharmacies(stateId);
          message.success(res.data.message);
        }
      })
      .catch((error) => {
        console.log("================== error ========================", error);
        const { response } = error;
        if (response) {
          const { data } = response;
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error("Unable to Edit State. Please try again!");
          }
        } else {
          message.error("Unable to Edit State. Please try again!");
        }
      });
  };

  const onCancelingEdit = () => {
    setStateDetails([
      {
        name: ["stateName"],
        value: "",
      },
      {
        name: ["oneClickPrescribeEligible"],
        value: false,
      },
    ]);
    afterStateEdit("");
  };

  const renderBulkPharmacyUpdateControls = ({ form }) => (
    <Row gutter={2} align="top" justify="start">
      <Col span={6}>
        <Form.Item name="shouldBulkUpdatePharmacy" valuePropName="checked">
          <Switch onClick={(checked) => {
            if (checked) {
              Modal.confirm({
                content: 'Cases will be updated to the selected pharmacy at 11:00PM PDT.',
                onCancel: () => form.setFieldsValue({ shouldBulkUpdatePharmacy: false })
              })
            }
          }} />
        </Form.Item>
      </Col>
      <Col span={16}>
        <span style={{ fontSize: '.75rem', color: 'grey' }}>Update All Open Cases In This Category/State To The Selected Pharmacy</span>
      </Col>
    </Row>
  );

  return (
    <StateForm
      mode="edit"
      form={form}
      fields={fields}
      onFieldsChange={(changedFields, allFields) => {
        setStateDetails(allFields);
      }}
      onFinish={onFinish}
      states={states}
      telemedicineCategory={telemedicineCategory}
      consultationType={consultationType}
      listOfPharmacies={listOfPharmacies}
      fetchPharmacies={fetchPharmacies}
      pharmacyLoading={pharmacyLoading}
      addedTeleMedicineCategory={addedTeleMedicineCategory}
      setAddedTeleMedicineCategory={setAddedTeleMedicineCategory}
      onCategoryAdd={addCategory}
      onCategoryRemove={(category) => removeCategory(category.categoryId)}
      renderBulkPharmacyUpdateControls={renderBulkPharmacyUpdateControls}
      onCancel={onCancelingEdit}
    />
  );
};

export default EditState;
